import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import studentReducer from "./slices/studentSlice";
import loadingReducer from "./slices/loadingSlice";
import contentReducer from "./slices/contentSlice";
import attendanceReducer from "./slices/attendanceSlice";
import chatReducer from "./slices/chatSlice";
import artworkReducer from "./slices/artworkSlice";
import announcementReducer from "./slices/announcementSlice";
import { errorMiddleware } from "./middleware/errorMiddleware";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    student: studentReducer,
    loading: loadingReducer,
    content: contentReducer,
    attendance: attendanceReducer,
    chat: chatReducer,
    artwork: artworkReducer,
    announcement: announcementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(errorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
